
import React from 'react';
import { useLogoUrl } from '@/hooks/useLogoUrl';

const FooterBranding: React.FC = () => {
  const logoUrl = useLogoUrl();

  return (
    <div className="mb-6 md:mb-0 w-64 md:w-80">
      <img
        src={logoUrl || '/assets/referme-logo.png'}
        alt="ReferMe.site"
        className="block w-full h-auto max-h-24 object-contain mb-2"
      />
      {!logoUrl && (
        <p className="text-gray-600 text-sm">Refer friends, earn rewards</p>
      )}
    </div>
  );
};

export default FooterBranding;
